<template>
  <label class="flex flex-col gap-1.5">
    <span v-if="label" class="flex items-center gap-2 text-sm font-medium text-foreground">
      {{ label }}
      <span v-if="optional" class="text-xs text-muted-foreground font-normal">(اختیاری)</span>
    </span>
    <slot />
    <span v-if="error" class="text-xs text-[var(--danger)]">{{ error }}</span>
    <span v-else-if="success" class="text-xs text-[var(--success)]">{{ success }}</span>
    <span v-else-if="hint" class="text-xs text-muted-foreground">{{ hint }}</span>
  </label>
</template>

<script setup lang="ts">
defineProps<{
  label?: string
  hint?: string
  error?: string
  success?: string
  optional?: boolean
}>()
</script>
